module.exports = __webpack_public_path__ + "static/media/Rain_storm.4d554e87.svg";